// extracted by mini-css-extract-plugin
export default {"label":"NavigateLabel_label__EnYPp","rightContainer":"NavigateLabel_rightContainer__6Cwgf"};